import axios from "axios";
import {get} from "./common";


export const vendorClientReviewCheckToken = async (token) => {
    try {
        const res = await get(`${process.env.REACT_APP_API_BASE_URL}/api/public/v1/token/check?token=${token}&type=1`);
        if (!res)
            return null
        return res;
    } catch (error) {
        console.error('Error store review:', error);
        return null;
    }
};

export const vendorClientReviewSubmit = async (payload) => {
    try {
        const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/public/v1/vendor/client-review/store`, payload);
        return response.data;
    } catch (error) {
        console.error('Error store review:', error);
        return null;
    }
};

export const getUserLinkedinData = async (code, redirect_url) => {
    try {
        const res = await get(`${process.env.REACT_APP_API_BASE_URL}/api/public/v1/external/linkedin/user-info?code=${code}&redirect_url=${redirect_url}`);
        if (!res)
            return null
        return res;
    } catch (error) {
        console.error('Error store review:', error);
        return null;
    }
};